import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';
import { BehaviorSubject } from 'rxjs';
import html2canvas from 'html2canvas';
import { saveAs } from 'file-saver';

@Injectable({
  providedIn: 'root'
})
export class CoreService {

  constructor() { }

  getOptionsDatatable(callback: (dtParams: any, cb: any) => void, searchPlaceholder: string = 'Cari Data') {
    return {
      serverSide: true,
      processing: true,
      ordering: false,
      searching: true,
      language: {
        searchPlaceholder: searchPlaceholder,
        search: '',
        paginate: {
          first: 'Pertama',
          last: 'Terakhir',
          next: 'Berikutnya',
          previous: 'Sebelumnya',
        },
        info: 'Memperlihatkan _START_ hingga _END_ dari _TOTAL_ entri',
        infoEmpty: 'Memperlihatkan 0 hingga 0 dari 0 entri',
        lengthMenu: 'Memperlihatkan _MENU_ entri',
      },
      pageLength: 5,
      lengthMenu: [5, 10, 15, 20],
      ajax: callback,
    };
  }

  confirmSaveForm({
    title = 'Apakah anda yakin?',
    text = 'Apakah anda yakin ingin menyimpan pengisian ini?',
    confirmButtonText = 'Ya, Simpan Pengisian!',
    cancelButtonText = 'Tidak, Kembali ke form',
    reverseButtons = false
  } = {}) {
    return Swal.fire({
      title,
      text,
      icon: 'warning',
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText,
      cancelButtonText,
      reverseButtons,
      customClass: {
        confirmButton: 'btn-primary-swal-full',
        cancelButton: 'btn-primary-swal-outline',
      },
    });
  }

  confirmChangeStatus({
    title = 'Apakah anda yakin?',
    text = 'Apakah anda yakin ingin mengubah status pengajuan ini?',
    confirmButtonText = 'Ya, Simpan Perubahan!',
    cancelButtonText = 'Tidak',
    reverseButtons = false
  } = {}) {
    return Swal.fire({
      title,
      text,
      icon: 'warning',
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText,
      cancelButtonText,
      reverseButtons,
      customClass: {
        confirmButton: 'btn-primary-swal-full',
        cancelButton: 'btn-primary-swal-outline',
      },
    });
  }

  confirmCencelForm(
    title: string = 'Batalkan Pengisian?',
    text: string = 'Apakah anda yakin ingin membatalkan pengisian ini? Semua perubahan tidak akan tersimpan',
    confirmButtonText: string = 'Ya, Batalkan Pengisian!',
    cancelButtonText: string = 'Tidak, Kembali ke form'
  ) {
    return Swal.fire({
      title,
      text,
      icon: 'warning',
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText,
      cancelButtonText,
      customClass: {
        confirmButton: 'btn-danger-swal-outline',
        cancelButton: 'btn-primary-swal-full',
      },
    });
  }

  confirmDeleteData({
    title = 'Apakah kamu yakin?',
    earlyText = 'Data ',
    text = ' ini tidak dapat diakses setelah kamu menghapus datanya',
    confirmButtonText = 'Ya, Hapus data ini!',
    cancelButtonText = 'Tidak, batal hapus data',
    menu = '',
    reverseButtons = true
  } = {}) {
    const fullText = earlyText + menu + text;
    return Swal.fire({
      title,
      text: fullText,
      icon: 'warning',
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText,
      cancelButtonText,
      reverseButtons,
      customClass: {
        confirmButton: 'btn-primary-swal-full',
        cancelButton: 'btn-danger-swal-outline',
      },
    });
  }



  checkValidasi(listValidasi, formModel, is_submit_first_form) {
    let isset_empty_form = false;

    Object.keys(listValidasi).forEach((field) => {
      const { label, required, max, type } = listValidasi[field];
      const element = document.getElementById(field);
      let errorElement = document.getElementById(`${field}_error`);
      const value = formModel[field];



      if (!element) {
        // console.warn(`Element dengan ID "${field}" tidak ditemukan.`);
        return;
      }

      // Jika elemen error belum ada, buat dan tambahkan ke DOM
      if (!errorElement) {
        errorElement = document.createElement('span');
        errorElement.id = `${field}_error`;
        errorElement.className = 'text-error-validation';
        element.insertAdjacentElement('afterend', errorElement);
      }

      if (!element || !errorElement) return;

      // Fungsi bantu untuk menambahkan atau menghapus error
      const setError = (message) => {
        isset_empty_form = true;
        element.classList.add('has-danger');
        errorElement.innerHTML = message;
      };

      const removeError = () => {
        element.classList.remove('has-danger');
        errorElement.innerHTML = '';
      };


      // Validasi required
      if (type == 'multiple' && required && is_submit_first_form && value.length <= 0) {
        setError(`Field ${label} wajib diisi`);
        element.children[0]?.classList?.add('has-danger');
        return;
      }

      // Validasi panjang maksimum
      if (max && value?.length > max) {
        setError(`Field ${label} harus memiliki maksimal ${max} karakter`);
        return;
      }

      // Validasi required
      if (required && is_submit_first_form && (!value || value === '')) {
        setError(`Field ${label} wajib diisi`);
        element.children[0]?.classList?.add('has-danger');
        return;
      }

      // Hapus error jika tidak ada masalah
      removeError();
      element.children[0]?.classList?.remove('has-danger');
    });

    return !isset_empty_form;
  }



  private variableNavSidebarSubject = new BehaviorSubject<any[]>([]);
  variableNavSidebar$ = this.variableNavSidebarSubject.asObservable();

  setVariableNavSidebar(value: any) {
    // Dapatkan nilai saat ini
    const currentValue = this.variableNavSidebarSubject.getValue();

    // Update dengan data baru
    this.variableNavSidebarSubject.next([...currentValue, value]);
  }

  downloadElement(elemenId) {
    const element = document.getElementById(elemenId) as HTMLElement;
    if (element) {
      let formatFileName = elemenId.replace('_unduh', '').replace(/[A-Z]/g, (match) => '-' + match.toLowerCase()).replace(/^-/, '') + '.png';

      const padding = 40; // Padding 40px

      // Tambahkan style sementara untuk menyembunyikan elemen saat screenshot
      const style = document.createElement('style');
      style.innerHTML = `
        .exclude-from-screenshot-temp {
          display: none !important;
        }
      `;
      document.head.appendChild(style);

      const buttons = element.querySelectorAll('.exclude-from-screenshot');
      buttons.forEach(button => button.classList.add('exclude-from-screenshot-temp'));

      html2canvas(element, {
        scale: 4
      }).then(canvas => {
        // Hapus style setelah screenshot selesai
        document.head.removeChild(style);
        buttons.forEach(button => button.classList.remove('exclude-from-screenshot-temp'));

        // Buat canvas baru dengan ukuran lebih besar untuk padding
        const paddedCanvas = document.createElement('canvas');
        const context = paddedCanvas.getContext('2d');

        paddedCanvas.width = canvas.width + padding * 2;
        paddedCanvas.height = canvas.height + padding * 2;

        if (context) {
          // Isi background putih (opsional)
          context.fillStyle = '#fff';
          context.fillRect(0, 0, paddedCanvas.width, paddedCanvas.height);

          // Gambar chart di tengah canvas dengan padding
          context.drawImage(canvas, padding, padding);

          paddedCanvas.toBlob(blob => {
            if (blob) {
              saveAs(blob, formatFileName);
            }
          });
        }
      });
    } else {
      console.error('Element not found');
    }
  }


  statusMeritalOptions = [
    { label: 'Lajang', value: 1 },
    { label: 'Menikah', value: 2 },
    { label: 'Cerai', value: 3 },
    { label: 'Lainnya', value: 4 }
  ];

  statusPKPOptions = [
    { label: 'Ya', value: '1' },
    { label: 'Tidak', value: '0' },
  ];

  statusGenderOptions = [
    { label: 'Laki - laki', value: 1 },
    { label: 'Perempuan', value: 2 },
  ];

  tipeSediaanOptions = [
    { label: 'cair', value: 'cair' },
    { label: 'Semi padat', value: 'semi padat' },
    { label: 'Bubuk', value: 'bubuk' },
    { label: 'Cairan kental', value: 'cairan kental' },
    { label: 'Padat', value: 'padat' },
    { label: 'Lainnya', value: 'other' }
  ];

  tujuanPenggunaanOptions = [
    { label: 'Badan', value: 'badan' },
    { label: 'Wajah', value: 'wajah' },
    { label: 'Lainnya', value: 'other' }
  ];

  approvalMerekStatuses = [
    { value: 0, label: 'Draft', icon: 'bx bx-pencil', bgColor: '#f0f0f0', color: '#6c757d' },
    { value: 1, label: 'Pending', icon: 'bx bx-time', bgColor: '#FFF3CD', color: '#856404' },
    { value: 2, label: 'Disetujui', icon: 'bx bx-check', bgColor: '#D4EDDA', color: '#155724' },
    { value: 3, label: 'Ditolak', icon: 'bx bx-x', bgColor: '#F8D7DA', color: '#721C24' },
    { value: 4, label: 'Cancel', icon: 'bx bx-x', bgColor: '#E2E3E5', color: '#6C757D' },
  ];

  getApprovalStatusMerekInfo(value: number) {
    return this.approvalMerekStatuses.find(item => item.value === value)
      || { label: 'Unknown', icon: '', bgColor: '#F5F5F5', color: '#333' };
  }


  //// MAKLON

  approvalMaklonStatuses = [
    { value: 0, label: 'Draft', icon: 'bx bx-pencil', bgColor: '#E2E3E5', color: '#6C757D' },
    { value: 1, label: 'Pending', icon: 'bx bx-time', bgColor: '#FFF3CD', color: '#856404' },
    { value: 2, label: 'Disetujui', icon: 'bx bx-check', bgColor: '#D4EDDA', color: '#155724' },
    { value: 3, label: 'Ditolak', icon: 'bx bx-x', bgColor: '#F8D7DA', color: '#721C24' },
    { value: 4, label: 'Cancel', icon: 'bx bx-x', bgColor: '#E2E3E5', color: '#6C757D' },
  ];


  getApprovalStatusMaklonInfo(value: number) {
    return this.approvalMaklonStatuses.find(item => item.value === value)
      || { label: 'Unknown', icon: '', bgColor: '#F5F5F5', color: '#333' };
  }


  prosesMaklonStatuses = [
    { value: 0, label: 'Not Started', icon: 'bx bx-time', bgColor: '#E2E3E5', color: '#6C757D' },
    { value: 1, label: 'Revision Requested', icon: 'bx bx-edit', bgColor: '#FFF3CD', color: '#856404' },
    { value: 2, label: 'Sample Prepared', icon: 'bx bx-package', bgColor: '#D1ECF1', color: '#0C5460' },
    { value: 3, label: 'Sample Tested', icon: 'bx bx-flask', bgColor: '#D4EDDA', color: '#155724' },
    { value: 4, label: 'Sample Shipped', icon: 'bx bx-send', bgColor: '#CCE5FF', color: '#004085' },
    { value: 5, label: 'Sample Received', icon: 'bx bx-box', bgColor: '#E8EAF6', color: '#1A237E' },
    { value: 6, label: 'Sample Approve', icon: 'bx bx-box', bgColor: '#E8EAF6', color: '#1A237E' },
    { value: 7, label: 'Done', icon: 'bx bx-box', bgColor: '#E8EAF6', color: '#1A237E' },
  ];

  getProsesStatusMaklonInfo(value: number) {
    return this.prosesMaklonStatuses.find(item => item.value === value)
      || { label: 'Unknown', icon: '', bgColor: '#F5F5F5', color: '#333' };
  }



  paymentStatus = [
    { value: 0, label: 'Draft', icon: 'bx bx-pencil', bgColor: '#E2E3E5', color: '#6C757D' },
    { value: 1, label: 'Pending', icon: 'bx bx-time', bgColor: '#FFF3CD', color: '#856404' },
    { value: 2, label: 'Paid', icon: 'bx bx-check-circle', bgColor: '#D4EDDA', color: '#155724' },
    { value: 3, label: 'Expired', icon: 'bx bx-x-circle', bgColor: '#F8D7DA', color: '#721C24' },
    { value: 4, label: 'Refunded', icon: 'bx bx-undo', bgColor: '#E2E3E5', color: '#383D41' },
  ];

  getPaymentStatusInfo(value: number) {
    return this.paymentStatus.find(item => item.value === value)
      || { label: 'Unknown', icon: '', bgColor: '#F5F5F5', color: '#333' };
  }
}



